// Constants for different requests for current reducer
export default {
  tsByEmployee: 'TS_BY_EMPLOYEE',
};
